<template>
  <div
    ref="containerEl"
    tabindex="-1"
    class="container"
    :style="{ ...getFontSizeForChatInterface('bodyText') }"
  >
    <div class="text-header">
      <BaseIcon
        name="CheckCircle"
        height="32px"
        width="32px"
        aria-label="check icon"
      />
      <div class="msg">
        <div :style="{ ...getFontSizeForChatInterface('title') }">
          {{ sendTranslatedValue(`${surveyForm.THANK_YOU}`, `Thank You!`) }}
        </div>
        <div>
          {{
            sendTranslatedValue(
              `${surveyForm.FOR_YOUR_FEEDBACK}`,
              `for completing the survey`
            )
          }}
        </div>
      </div>
    </div>
    <button
      :id="`show-more-btn-${uniqueId}`"
      class="show-more-btn tab-focused-btn"
      @click="toggleShowData(true)"
    >
      {{ sendTranslatedValue(`${surveyForm.VIEW_RESPONSE}`, `View response`) }}
    </button>
  </div>
</template>
<script>
import BaseIcon from '@/views/BaseIcon.vue'
import { surveyForm } from '@/services/constants'
import { v4 as uuidV4 } from 'uuid'
import fontSizeMixin from '@/mixins/fontSizeMixin'

export default {
  components: {
    BaseIcon
  },
  mixins: [fontSizeMixin],
  props: {
    submittedData: {
      type: Object,
      default: () => {}
    },
    schema: {
      type: Object,
      default: () => {}
    },
    surveyId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      surveyForm: surveyForm,
      uniqueId: uuidV4()
    }
  },
  computed: {
    getOverAllRatingAnswer() {
      if (!this.submittedData.feedbackValue) return ''
      return this.submittedData.feedbackValue === surveyForm.POSITIVE
        ? this.sendTranslatedValue(
            `${surveyForm.GOOD.toUpperCase()}`,
            surveyForm.GOOD
          )
        : this.sendTranslatedValue(
            `${surveyForm.BAD.toUpperCase()}`,
            surveyForm.BAD
          )
    },
    getDidWeResolveAnswer() {
      const issueResolved = this.submittedData.issueResolved
      if (issueResolved === true)
        return this.sendTranslatedValue(
          `${surveyForm.BUTTON_YES}`,
          `${surveyForm.YES}`
        )
      else if (issueResolved === false)
        return this.sendTranslatedValue(
          `${surveyForm.BUTTON_NO}`,
          `${surveyForm.NO}`
        )
      else return ''
    },
    getAddFeedbackAnswer() {
      if (!this.submittedData.additionalFeedback) return ''
      return `"${this.submittedData.additionalFeedback}"`
    },
    getsuggestionTitle() {
      if (!this.submittedData.feedbackValue) return ''
      if (this.submittedData.feedbackValue === surveyForm.POSITIVE) {
        return this.sendTranslatedValue(
          `${surveyForm.SURVEY_DOT}${this.surveyId}${surveyForm.DOT}${surveyForm.POSITIVE_FEEDBACK_HEADER}`,
          this.submittedData.suggestionTitle
        )
      } else {
        return this.sendTranslatedValue(
          `${surveyForm.SURVEY_DOT}${this.surveyId}${surveyForm.DOT}${surveyForm.NEGATIVE_FEEDBACK_HEADER}`,
          this.submittedData.suggestionTitle
        )
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.$refs.containerEl?.focus()
    }, 100)
  },
  methods: {
    toggleShowData() {
      this.$emit('show-survey-submitted', true)
    },
    sendTranslatedValue(key, defaultValue) {
      return this.$te(key) ? this.$t(key) : defaultValue
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  width: 204px;
  background: #ffffff;
  border: 1px solid #cdcdcd;
  border-radius: 8px;
  padding: 20px;
  @media screen and (min-width: 400px) {
    width: 294px;
  }
}
.text-header {
  display: flex;
  gap: 16px;
}
.msg {
  :nth-child(1) {
    font-weight: 600;
  }
  :nth-child(2) {
    color: #6d6d6d;
    font-weight: 400;
    font-size: inherit;
  }
}
.show-more-btn {
  margin-top: 14px;
  color: var(--user-chat-color);
  font-weight: 600;
  font-size: inherit;
  margin-left: 48px;
  cursor: pointer;
}
</style>
